import React from 'react'
import ErrorBase from '../components/ErrorBase'

function NotFound() {
    return <ErrorBase
        errorCode={404}
        src="/images/blinking.gif"
        errorDescription="Looks like the page you were looking for doesn’t exist"
        className='text-primary'
    />
}

export default NotFound